import { PropsWithChildren } from 'react';
import { Form } from '@ant-design/compatible';
import { FormProps } from '@ant-design/compatible/lib/form';
import '@ant-design/compatible/lib/form/style/index.less';
import styled from 'styled-components';

import { FormHeader, MainFormHeader } from 'common/components/styled';
import { breakpoints } from 'theme/variables';

const StyledForm = styled(Form)`
    && {
        width: 100%;
        margin: 0 auto;
        padding: 1rem;
        font-family: 'Inter', sans-serif;

        ${breakpoints.small} {
            padding: 1.25rem 1.5rem;
        }

        ${breakpoints.medium} {
            padding: 1.5rem 2rem;
        }

        .ant-legacy-form-item {
            margin-bottom: 20px;
        }

        .ant-legacy-form-item-label label {
            font-family: 'Inter', sans-serif;
            font-weight: 600;
            font-size: 0.84rem;
            color: #3a4555;
        }

        .ant-legacy-form-item-required::before {
            color: #dc2626;
        }

        .ant-legacy-form-explain {
            font-size: 0.8rem;
            margin-top: 4px;
        }

        .ant-input {
            border-radius: 8px;
            border-color: #dce1e8;
            padding: 8px 12px;
            font-family: 'Inter', sans-serif;
            font-size: 0.9rem;
            color: #3a4555;
            transition: all 0.2s;

            &:hover {
                border-color: #b8c2cf;
            }

            &:focus {
                border-color: #1e7a45;
                box-shadow: 0 0 0 3px rgba(30, 122, 69, 0.08);
            }

            &::placeholder {
                color: #b0bac6;
            }
        }

        .ant-input-lg {
            padding: 10px 14px;
            font-size: 0.92rem;
        }

        textarea.ant-input {
            padding: 10px 14px;
            min-height: 100px;
        }

        .ant-select-selector {
            border-radius: 8px !important;
            border-color: #dce1e8 !important;
            min-height: 40px;
            font-family: 'Inter', sans-serif;
        }

        .ant-select-lg .ant-select-selector {
            min-height: 44px;
        }

        .ant-calendar-picker {
            width: 100%;
        }

        .ant-calendar-picker-input {
            border-radius: 8px;
            border-color: #dce1e8;
            padding: 8px 12px;
            height: auto;
            min-height: 40px;
            font-family: 'Inter', sans-serif;
        }

        .ant-btn {
            border-radius: 8px;
            font-family: 'Inter', sans-serif;
            height: 40px;
        }

        .ant-btn-primary {
            height: 46px;
            font-size: 0.92rem;
            font-weight: 600;
        }
    }
`;

type Props = FormProps &
    PropsWithChildren<{
        header?: JSX.Element | string;
        bigHeader?: boolean;
    }>;

export const StyledAntd3Form = (props: Props) => {
    const HeaderComponent = props.bigHeader ? MainFormHeader : FormHeader;

    return (
        <StyledForm {...props}>
            {props.header && <HeaderComponent>{props.header}</HeaderComponent>}
            {props.children}
        </StyledForm>
    );
};
